import React, { useState } from 'react';

interface TextSelectorProps {
  texts: string[];
  icons?: string[];
  handleChange: (text: string) => void,
  selected?: string
}

const TextSelector: React.FC<TextSelectorProps> = ({ texts, icons, handleChange, selected }) => {
  const [selectedText, setSelectedText] = useState(texts[0]);

  const handleTextClick = (text: string) => {
    setSelectedText(text);
    handleChange(text)
  };

  return (
    <div className={`tw-space-y-1`}>
      {texts.map((text, index) => (
        <div
          key={text}
          className={`tw-p-1 tw-cursor-pointer tw-px-2 tw-flex tw-items-center tw-font-normal tw-text-sm ${
            (selected ?? selectedText) === text
              ? 'tw-bg-[#EEEEEF] tw-rounded tw-text-[#091CAA]'
              : 'tw-bg-white'
          }`}
          onClick={() => handleTextClick(text)}
        >
          {icons && icons[index] && <img className={`tw-mr-2`} src={icons[index]} alt=''></img>}
          {text}
        </div>
      ))}
    </div>
  );
};

export default TextSelector;
